// extracted by mini-css-extract-plugin
export var active = "_ku-2";
export var recordingDot = "_ku-1";
export var recordingIndicator = "_ku-0";